module.exports = __webpack_public_path__ + "c8228e735ab52d6ab6432fb45217d76f.svg";